import axios from 'axios';
import { currentHttpOptions } from '../../../utils';

const API_URL = '/api/v1/admin/notification';

/**
 * @returns {Promise<ApiAdmin.GetNotificationListResponse>}
 */
export const getGenericNotificationList = () => axios.get(`${process.env.REACT_APP_API_DOTNET}${API_URL}`,
    currentHttpOptions());

/**
 * @returns {Promise<ApiAdmin.GetNotificationTagListResponse>}
 */
export const getNotificationTagList = () => axios.get(`${process.env.REACT_APP_API_DOTNET}${API_URL}/tags`,
    currentHttpOptions());
